import { AbstractReportPmsApiService } from '../abstract-report.service';
import { FrontDeskInHouseReport } from '../../../models/reports/front-desk/in-house-report.model';

/**
 * @class FrontDeskInHouseReportPmsApiService
 * @extends {AbstractReportPmsApiService<FrontDeskInHouseReport>}
 */
export class FrontDeskInHouseReportPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/front-desk/in-house';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {FrontDeskInHouseReport}
     * @protected
     */
    newModel(attributes, ...params) {

        return new FrontDeskInHouseReport(attributes);
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/front-desk/in-house-report.service.js